import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Client } from '@/types/client';
import { Modal } from '@/types/modal';
import Grid, { GridAction, itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import ModalView from '@/components/modals/Modal';
import { useClientShippingFromAddress } from '@/hooks/client';
import { LoadingBodyModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ client: Client }> = ({ client }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState<Modal | null>(null);

  const [open, setOpen] = useState(false);

  const data = useClientShippingFromAddress(client.clientId, client.clientShippingAddressId, open);

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('common.update').toUpperCase(),
      onClick: () => setModal({ kind: 'UpdateClientShippingAddress', client, onClose: () => setModal(null) }),
      disabled: !client.clientId || !client.clientShippingAddressId,
    },
  ];

  const shippingFromAddress = data.kind === 'Loaded' ? data.data : null;

  const items = [
    itemText(t('client.shipping.first_name'), shippingFromAddress?.firstName),
    itemText(t('client.shipping.surname'), shippingFromAddress?.lastName),
    itemText(t('client.shipping.address1'), shippingFromAddress?.line1),
    itemText(t('client.shipping.address2'), shippingFromAddress?.line2),
    itemText(t('client.shipping.district'), shippingFromAddress?.district),
    itemText(t('client.shipping.city'), shippingFromAddress?.city),
    itemText(
      t('client.shipping.province'),
      shippingFromAddress?.province
        ? shippingFromAddress?.province
        : shippingFromAddress?.state
          ? shippingFromAddress?.state
          : shippingFromAddress?.county,
    ),
    itemText(t('client.shipping.zip'), shippingFromAddress?.zipCode),
    itemText(t('client.shipping.country'), shippingFromAddress?.country),
    itemText(t('client.shipping.company_name'), shippingFromAddress?.company),
    itemText(t('client.shipping.phone_country'), shippingFromAddress?.phoneNumberPrefix),
    itemText(t('client.shipping.phone_number'), shippingFromAddress?.phoneNumber),
  ];

  return (
    <>
      <Container
        title={t('client.shipping.title')}
        actions={actions}
        testId="shipping_info"
        handler={{ open, setOpen }}
      >
        {open && data.kind === 'Called' ? (
          <LoadingBodyModal />
        ) : (
          <Grid
            column={5}
            items={items}
          />
        )}
      </Container>
      <ModalView modal={modal} />
    </>
  );
};

export default View;
